import React, { type JSX } from "react";
import type { AdminProjectionFreshness } from "../../contracts/admin-read-models";
import { AdminStatusBadge, toAdminFreshnessBadgeValue } from "./admin-status-badge";

export type AdminSourceStatusGridItem = {
  source: string;
  freshness: AdminProjectionFreshness;
  sourceKind?: string;
  sourceKindLabel?: string;
};

export type AdminSourceStatusGridProps = {
  items: AdminSourceStatusGridItem[];
  statusLabel: string;
};

export function AdminSourceStatusGrid(props: AdminSourceStatusGridProps): JSX.Element {
  return (
    <div
      style={{
        display: "grid",
        gap: "8px",
        gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
      }}
    >
      {props.items.map((item) => (
        <div
          key={item.source}
          style={{
            display: "grid",
            gap: "6px",
            padding: "12px 14px",
            borderRadius: "14px",
            border: "1px solid rgba(148, 163, 184, 0.22)",
            background: "rgba(248, 250, 252, 0.9)",
          }}
        >
          <strong style={{ color: "#18212b", fontSize: "0.88rem" }}>
            {item.sourceKindLabel
              ? `${item.source} (${item.sourceKindLabel})`
              : item.sourceKind
                ? `${item.source} (${item.sourceKind})`
                : item.source}
          </strong>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              gap: "10px",
              alignItems: "center",
            }}
          >
            <span style={{ color: "#64748b", fontSize: "0.8rem" }}>{props.statusLabel}</span>
            <AdminStatusBadge value={toAdminFreshnessBadgeValue(item.freshness)} />
          </div>
        </div>
      ))}
    </div>
  );
}
